import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import useAuthenticationPage from './useAuthenticationPage';

const AuthenticationPage = () => {

  useAuthenticationPage();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
      }}
    >
      <Container component="main" sx={{ mt: 8, mb: 2 }} maxWidth="sm">
        <Typography variant="h4" component="h1" gutterBottom>
          Authenticating user credentials...
        </Typography>
        <Typography variant="h5" component="h2" gutterBottom>
          {`Please wait...`}
        </Typography>
      </Container>

    </Box>
  )
}

export default AuthenticationPage;